import { observer } from 'mobx-react';

import CollectionPreview from '@/collection/components/CollectionPreview/CollectionPreview';
import CollectionPreviewGrid from '@/collection/components/CollectionPreview/CollectionPreviewGrid/CollectionPreviewGrid';
import { buildProductTypeFragments } from '@/collection/components/CollectionPreview/CollectionPreviewGrid/CollectionPreviewGrid.utils';
import Icon from '@/common/components/Icon/Icon';
import { setS3ImageOptions } from '@/common/helpers/setS3ImageOptions';
import { DriveItemType } from '@/drive/entities/DriveItem/DriveItem';
import { DriveItemPreviewData } from '@/drive/types/DriveItemPreviewData';
import MediaPlaceholder from '@/media/components/MediaPlaceholder/MediaPlaceholder';
import PreviewImage from '@/media/components/PreviewImage/PreviewImage';
import ProjectPlaceholder from '@/media/components/ProjectPlaceholder/ProjectPlaceholder';

import styles from './DriveItemPreview.module.css';

export interface DriveItemPreviewProps {
  preview: DriveItemPreviewData;
  size: number;
  renderLabelClassName?: string;
}

function DriveItemPreview(props: DriveItemPreviewProps) {
  const { preview, size, renderLabelClassName } = props;

  if (preview.preview?.url) {
    return (
      <PreviewImage
        url={setS3ImageOptions(preview.preview.url, size)}
        size={size}
        bg={preview.preview.bg}
        isRender={preview.preview.isRender}
        renderLabelClassName={renderLabelClassName}
      />
    );
  }

  if (preview.type === DriveItemType.CarbonProject) {
    return <ProjectPlaceholder width={size} height={size} />;
  } else if (preview.type === DriveItemType.Folder) {
    return <Icon name="folder" className={styles.folderIcon} style={{ fontSize: size }} />;
  } else if (preview.type === DriveItemType.Collection || preview.type === DriveItemType.CollectionSubscription) {
    if (preview.collectionId) {
      return <CollectionPreview collectionId={preview.collectionId} containerSize={size} gap={2} />;
    } else {
      return (
        <CollectionPreviewGrid
          fragments={buildProductTypeFragments(preview.productType)}
          containerSize={size}
          gap={2}
        />
      );
    }
  } else if (preview.type === DriveItemType.Url) {
    return <Icon name="link" className={styles.urlIcon} style={{ fontSize: size }} />;
  } else {
    return <MediaPlaceholder shape={preview.productType ?? undefined} size={size} />;
  }
}

export default observer(DriveItemPreview);
